/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateNumericEvaluationParameterDto } from './CreateNumericEvaluationParameterDto';
import {
    instanceOfCreateNumericEvaluationParameterDto,
    CreateNumericEvaluationParameterDtoFromJSON,
    CreateNumericEvaluationParameterDtoFromJSONTyped,
    CreateNumericEvaluationParameterDtoToJSON,
} from './CreateNumericEvaluationParameterDto';

/**
 * @type GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameter
 * 
 * @export
 */
export type GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameter = CreateNumericEvaluationParameterDto;


export function GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameterFromJSON(json: any): GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameter {
    return GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameterFromJSONTyped(json, false);
}

export function GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameter {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...CreateNumericEvaluationParameterDtoFromJSONTyped(json, true) };
    return  CreateNumericEvaluationParameterDtoFromJSONTyped(json, true);
}

export function GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameterToJSON(value?: GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfCreateNumericEvaluationParameterDto(value)) {
        return CreateNumericEvaluationParameterDtoToJSON(value as CreateNumericEvaluationParameterDto);
    }

    return {};
}

/**
 * Check if a given object implements the GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameter interface.
 */
export function instanceOfGetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameter(value: any): value is GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameter {
    if (instanceOfCreateNumericEvaluationParameterDto(value)) return true;
    return false;
}

